const video = document.querySelector('video#external') as HTMLVideoElement;

if (video) {
  video.pause();

  const observer = new IntersectionObserver(
    (entries: IntersectionObserverEntry[]) => {
      entries.forEach(async (entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting) {
          // When iframe is visible, play video
          await video.play();
        } else {
          // When iframe is not visible, pause video
          video.pause();
        }
      });

      // Trigger as soon as any part of the iframe enters or leaves the viewport
    },
    { threshold: 0 }
  );

  observer.observe(video);
}
